import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
// import { version } from '../../../../../package.json';
import whatsAppIcon from '../../../../assets/images/icons/whatsapp';
import { environment } from '../../../../environments/environment';
import { CompanyService } from '../../../service/company.service';
import { LayoutService } from '../../../service/layout.service';
import { MkgSpeedDialConfig } from '../../../shared/components/speed-dial/speed-dial.component';
import { DataService } from '../../../service/data.service';
import { COMPANY_STATE, IA_MODULE_STATE } from '@interface/company';
import { combineLatest, map } from 'rxjs';
import { Utilities } from '@app/class/utilities';
import { APPORTIONMENT_CODE, Rateio } from '@app/shared/enums/apportionment';
import { Money } from 't5-common';
import { ABNT } from '@app/class/abnt';

@Component({
  selector: 'app-footer',
  //standalone: true,
  //imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit {
  COMPANY_STATE = COMPANY_STATE;
  IA_MODULE_STATE = IA_MODULE_STATE;

  isMakena = environment.makena;
  isPO360 = environment.dota;
  // APP_VERSION = version;
  APP_NAME: typeof environment.envName = environment.envName;
  showSupport = ['MekanicWEB', 'MekanicAGRO', 'PO360'].includes(this.APP_NAME);
  showChatAI = ['MekanicWEB', 'MekanicAGRO', 'PO360'].includes(this.APP_NAME);

  showTutorialWidget$ = combineLatest([
    this.dataService.user$,
    this.dataService.company$
  ]).pipe(
    map(([user, company]) => {
      const isLoggedIn = !!user;
      const hasCompany = !!company;

      return isLoggedIn && hasCompany;
    })
  );

  invoiceSpeedDialConfig: MkgSpeedDialConfig = {
    direction: 'top',
    triggerButton: {
      icon: "add",
      matColor: "accent"
    },
    buttons: [{
      label: "NFe",
      matColor: "primary",
      onClick: () => this.layout.newInvoice('NFe')
    },
    {
      label: "NFCe",
      matColor: "primary",
      onClick: () => this.layout.newInvoice('NFCe')
    },
    {
      label: "NFSe",
      matColor: "primary",
      onClick: () => this.layout.newInvoice('NFSe')
    },
    {
      label: "OIP",
      matColor: "primary",
      onClick: () => this.layout.newInvoice('OIP')
    },
    {
      label: "OIS",
      matColor: "primary",
      onClick: () => this.layout.newInvoice('OIS')
    }]
  }

  constructor(
    public layout: LayoutService,
    public companyService: CompanyService,
    private sanitizer: DomSanitizer,
    private iconRegistry: MatIconRegistry,
    protected dataService: DataService,
  ) {
  }

  ngOnInit() {
    this.iconRegistry.addSvgIconLiteral('whatsapp', this.sanitizer.bypassSecurityTrustHtml(whatsAppIcon));
  }


  protected readonly console = console;
  protected readonly alert = alert;
  protected readonly environment = environment;

  // test() {
  //   const total = Number(prompt('Qual o valor total ?'));
  //   const parcels = Number(prompt('Quantas parcelas?'));
  //   if (isNaN(total) || isNaN(parcels) || parcels <= 0) {
  //     alert('Valores inválidos!');
  //     return;
  //   }

  //   const upArr = new Array(parcels);
  //   const roundUpValue = Math.ceil(total / parcels * 100) / 100;
  //   for (let i = 0; i < upArr.length; i++) {
  //     upArr[i] = {
  //       id: i + 1,
  //       value: roundUpValue
  //     }
  //   }
  //   const upRateio = new Rateio({ array: upArr, expectedSum: total, property: 'value' }).test();

  //   const downArr = new Array(parcels);
  //   const roundDownValue = Math.floor(total / parcels * 100) / 100;
  //   for (let i = 0; i < downArr.length; i++) {
  //     downArr[i] = {
  //       id: i + 1,
  //       value: roundDownValue
  //     }
  //   }
  //   const downRateio = new Rateio({ array: downArr, expectedSum: total, property: 'value' }).test();

  //   const table = [];
  //   for (let i = 0; i < parcels; i++) {
  //     table.push({
  //       parcela: i + 1,
  //       ROUND_DOWN_FIRST: downRateio[i].first,
  //       ROUND_DOWN_FIRST_ONE: downRateio[i].firstOne,
  //       ROUND_DOWN_LAST_ONE: downRateio[i].lastOne,
  //       ROUND_DOWN_LAST: downRateio[i].last,
  //       ROUND_UP_FIRST: upRateio[i].first,
  //       ROUND_UP_FIRST_ONE: upRateio[i].firstOne,
  //       ROUND_UP_LAST_ONE: upRateio[i].lastOne,
  //       ROUND_UP_LAST: upRateio[i].last,
  //     })
  //   }

  //   const sum = {
  //     parcela: "TOTAL",
  //     ROUND_DOWN_FIRST: Money(table.reduce((sum, row) => sum + row.ROUND_DOWN_FIRST, 0)),
  //     ROUND_DOWN_FIRST_ONE: Money(table.reduce((sum, row) => sum + row.ROUND_DOWN_FIRST_ONE, 0)),
  //     ROUND_DOWN_LAST_ONE: Money(table.reduce((sum, row) => sum + row.ROUND_DOWN_LAST_ONE, 0)),
  //     ROUND_DOWN_LAST: Money(table.reduce((sum, row) => sum + row.ROUND_DOWN_LAST, 0)),
  //     ROUND_UP_FIRST: Money(table.reduce((sum, row) => sum + row.ROUND_UP_FIRST, 0)),
  //     ROUND_UP_FIRST_ONE: Money(table.reduce((sum, row) => sum + row.ROUND_UP_FIRST_ONE, 0)),
  //     ROUND_UP_LAST_ONE: Money(table.reduce((sum, row) => sum + row.ROUND_UP_LAST_ONE, 0)),
  //     ROUND_UP_LAST: Money(table.reduce((sum, row) => sum + row.ROUND_UP_LAST, 0))
  //   }

  //   table.push(sum);

  //   console.table(table);



  // }

  testAbnt() {
    const cases = [
      { value: 1.333, decimalPoints: 1, expectedValue: 1.3 },
      { value: 1.666, decimalPoints: 1, expectedValue: 1.7 },
      { value: 4.850, decimalPoints: 1, expectedValue: 4.8 },
      { value: 4.550, decimalPoints: 1, expectedValue: 4.6 },
      { value: 4.850, decimalPoints: 1, expectedValue: 4.8 },
      { value: 0.342, decimalPoints: 2, expectedValue: 0.34 },
      { value: 0.346, decimalPoints: 2, expectedValue: 0.35 },
      { value: 0.3452, decimalPoints: 2, expectedValue: 0.35 },
      { value: 0.3450, decimalPoints: 2, expectedValue: 0.34 },
      { value: 0.332, decimalPoints: 2, expectedValue: 0.33 },
      { value: 0.336, decimalPoints: 2, expectedValue: 0.34 },
      { value: 0.3352, decimalPoints: 2, expectedValue: 0.34 },
      { value: 0.3350, decimalPoints: 2, expectedValue: 0.34 },
      { value: 0.3050, decimalPoints: 2, expectedValue: 0.30 },
      { value: 0.3150, decimalPoints: 2, expectedValue: 0.32 },
      { value: 0.30500001, decimalPoints: 2, expectedValue: 0.31 },
      { value: 0, decimalPoints: 2, expectedValue: 0 },
      { value: 1, decimalPoints: 2, expectedValue: 1 },
      { value: -1, decimalPoints: 2, expectedValue: -1 },
      { value: 3, decimalPoints: 0, expectedValue: 3 },
      { value: -1.333, decimalPoints: 1, expectedValue: -1.3 },
      { value: -1.666, decimalPoints: 1, expectedValue: -1.7 },
      { value: -4.850, decimalPoints: 1, expectedValue: -4.8 },
      { value: -4.550, decimalPoints: 1, expectedValue: -4.6 },
      { value: -4.850, decimalPoints: 1, expectedValue: -4.8 },
      { value: -0.342, decimalPoints: 2, expectedValue: -0.34 },
      { value: -0.346, decimalPoints: 2, expectedValue: -0.35 },
      { value: -0.3452, decimalPoints: 2, expectedValue: -0.35 },
      { value: -0.3450, decimalPoints: 2, expectedValue: -0.34 },
      { value: -0.332, decimalPoints: 2, expectedValue: -0.33 },
      { value: -0.336, decimalPoints: 2, expectedValue: -0.34 },
      { value: -0.3352, decimalPoints: 2, expectedValue: -0.34 },
      { value: -0.335, decimalPoints: 2, expectedValue: -0.34 },
      { value: -0.3050, decimalPoints: 2, expectedValue: -0.30 },
      { value: -0.3150, decimalPoints: 2, expectedValue: -0.32 },
      { value: -0.30500001, decimalPoints: 2, expectedValue: -0.31 },
    ];

    const results = cases.map(c => {
      return {
        ...c,
        result: this.testValues(c.value, c.decimalPoints, c.expectedValue) ? "OK" : "FAIL"
      }
    });

    this.console.table(results, ["value", "decimalPoints", "expectedValue", "result"]);

  }

  testValues(value, decimalPoints, expectedValue): boolean {
    const result = ABNT.round(value, decimalPoints);
    return result === expectedValue;
  }
}